import Progress, { ProgressDTO } from '../Progress';

export const convertFromProgressDTO = (dto: ProgressDTO): Progress => dto;
